module.exports = __webpack_public_path__ + "img/consultation.1d42140.webp";